import { render } from "./Node.vue?vue&type=template&id=8d83f93a"
import script from "./Node.vue?vue&type=script&lang=ts"
export * from "./Node.vue?vue&type=script&lang=ts"
script.render = render

export default script